/* Stock Up Sale lander - countdown + Ajax add to cart with automatic discount */
(function () {
  if (window.__suStockUpInit) return;
  window.__suStockUpInit = true;

  var pad = function (n) { return String(n).padStart(2, '0'); };

  function tick() {
    var nodes = document.querySelectorAll('[data-su-countdown]');
    var now = Date.now();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var target = Date.parse(el.getAttribute('data-su-countdown'));
      if (isNaN(target)) { el.style.display = 'none'; continue; }
      var ms = Math.max(0, target - now);
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      if (el.hasAttribute('data-su-compact')) {
        el.textContent = d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s) + ' left';
        continue;
      }
      var set = function (sel, val) { var t = el.querySelector(sel); if (t) t.textContent = val; };
      set('[data-su-d]', d);
      set('[data-su-h]', pad(h));
      set('[data-su-m]', pad(m));
      set('[data-su-s]', pad(s));
    }
  }

  function toast(html) {
    var el = document.createElement('div');
    el.className = 'su su-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = html;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 400);
    }, 4000);
  }

  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }

  function refreshCartUI(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents(data);
      return true;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) {
      try {
        var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (parsed) bubble.innerHTML = parsed.innerHTML;
      } catch (e) {}
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-su-add]');
    if (!btn) return;
    event.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) { window.location.href = btn.getAttribute('data-fallback') || '/cart'; return; }
    if (btn.dataset.suBusy === '1') return;
    btn.dataset.suBusy = '1';

    var original = btn.innerHTML;
    btn.innerHTML = btn.getAttribute('data-loading-text') || 'Adding...';
    btn.setAttribute('disabled', 'disabled');

    applyDiscount(btn.getAttribute('data-discount')).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: Number(btn.getAttribute('data-quantity') || 1) }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (data && data.status && data.status !== 200) throw new Error(data.description || data.message || 'Add to cart failed');
      var opened = refreshCartUI(data);
      btn.innerHTML = btn.getAttribute('data-success-text') || 'Added to cart';
      if (!opened) {
        toast((btn.getAttribute('data-success-text') || 'Added to cart') + ' &middot; <a href="/cart">View cart</a>');
      }
      setTimeout(function () { btn.innerHTML = original; }, 2600);
    }).catch(function (err) {
      btn.innerHTML = original;
      toast((err && err.message ? err.message : 'Sorry, that could not be added.') + ' &middot; <a href="/cart">View cart</a>');
    }).then(function () {
      btn.removeAttribute('disabled');
      btn.dataset.suBusy = '0';
    });
  });

  function boot() {
    tick();
    setInterval(tick, 1000);
    var preload = document.querySelector('[data-su-apply-discount-on-load]');
    if (preload) applyDiscount(preload.getAttribute('data-su-apply-discount-on-load'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
